import { memo } from "react";
import { APP_IMAGES } from "../../constants/images";

const PermitHeader = ({ title }: { title: string }) => {
    return (
        <div className="border border-black">
            <div className="grid grid-cols-12">
                {/* Logo Section */}
                <div className="col-span-4 flex items-center justify-center">
                    <img
                        src={APP_IMAGES.logo}
                        alt="logo"
                        className="w-[180px] object-contain py-1"
                    />
                </div>

                {/* Title Section */}
                <div className="col-span-3 border-r border-l border-black">
                    <div className="text-center flex flex-col items-center justify-center h-full w-full">
                        <div className="flex items-center justify-center w-full h-full border-b border-black">
                            <p className="text-xs font-bold">Ministry of Foreign Affairs</p>
                        </div>
                        <div className="flex items-center justify-center w-full h-full">
                            <p className="text-xs font-bold">{title}</p>
                        </div>
                    </div>
                </div>

                <div className="col-span-2 border-r  border-black">
                    <div className="text-center flex flex-col items-center justify-center h-full w-full">
                        <div className="flex items-center justify-center w-full h-full border-b border-black">
                            <p className="text-[10px]">REF NO.</p>
                        </div>
                        <div className="flex items-center justify-center w-full h-full">
                            <p className="text-[10px]">Date & Time of Issue</p>
                        </div>
                    </div>
                </div>

                {/* Empty Values Section */}
                <div className="col-span-3 border-r  border-black">
                    <div className="text-center flex flex-col items-center justify-center h-full w-full">
                        <div className="flex items-center justify-center  w-full h-full  border-b border-black">
                            <p className="text-[10px]"></p>
                        </div>
                        <div className="flex items-center justify-center w-full h-full">
                            <p className="text-[10px]"></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default memo(PermitHeader);
